import axios from 'axios';
import store from '@/store';
import router from '@/router';
import keycloak from '../../keycloak';

export default {
  install() {
    axios.defaults.baseURL = '/api'; // Use relative path instead of environment variable
    if (import.meta.env.VITE_KEYCLOAK === 'true') {
      axios.interceptors.request.use((config) => {
        if (keycloak.authenticated) {
          // eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `Bearer ${keycloak.token}`;
        }
        return config;
      });
    } else {
      const token = store.state.auth.token ?? localStorage.getItem('jwt');
      axios.defaults.headers = {
        'Content-Type': 'application/json',
        Authorization: token,
      };

      // Add middleware for 401 responses
      axios.interceptors.response.use(
        (response) => response,
        (error) => {
          if (error.response?.status === 401
            && router.currentRoute.value.name !== 'login'
            && router.currentRoute.value.name !== 'evaluation'
            && router.currentRoute.value.name !== 'questionnaireEvaluation'
            && router.currentRoute.value.name !== 'questionnaire') {
            return router.push('/auth');
          }
          return Promise.reject(error);
        },
      );
    }
  },
};
